<template>
  <div>
  <el-select
    name="user"
    placeholder="All"
    filterable
    prefix-icon="el-icon-search" 
    remote
    :remote-method="referralSearch"
    default-first-option
    :allow-create="false"
    :clearable="true"
    v-model="referral"
    :value="value"
    :loading="loadingReferrals"
    v-loading="loadingReferrals"
    element-loading-spinner="qc-spinner"
    value-key="name"
    class="verification-select"
    @change="$emit('input', $event)" >
    <el-option-group v-if="referralOptions != null && referralOptions.length > 0" :label="'Type to search and select an option below'">
      <el-option
        v-for="item in referralOptions"
        :key="item.id"
        :label="item.name"
        :value="item.name"
        :disabled="item.disabled">
      </el-option>
    </el-option-group>
  </el-select>
  </div>
</template>

<script>
export default {
  name: 'referral-select',
  props: {
    value: String
  },
  data () {
    return {
      referral: this.value,
      loadingReferrals: false,
      referralOptions: this.value ? [this.value] : []
    }
  },
  watch: {
    value (value) {
      this.referral = value
    }
  },
  methods: {
    referralSearch(query) {
      if(query != null) {
        this.loadingReferrals = true
        this.doReferralSearch(query)
      }
    },
    doReferralSearch:_.debounce(function(query) {
      let listRequest = {
        page: 0,
        size: 10000,
        query: query
      }
      this.$api.getReferralList(listRequest)
        .then(response => {
          this.referralOptions = response.data.content
          this.loadingReferrals = false
        })
        .catch(error => {
          console.log("Failed to load referrals")
          console.log(error)
          this.loadingReferrals = false
        })  
    }, 200)
  }
}
</script>